import { DecodeHtml } from "../../utils/decodeHtml"
import { PropTypes } from 'prop-types';


const CareerProspect = ({data}) => {
    return (
        <div className="w-full   h-fit md:min-h-96 bg-white rounded-2xl border-2 border-stone-300 p-6 py-8 flex flex-col gap-5" >
            <div className="flex gap-4 items-center ">
                <img src="/assets/careerProspect.svg" alt="" />
                <span className="text-slate-900 text-lg font-bold ">Career Prospect</span>
            </div>
            <p className="whitespace-pre-line w-auto">
                {
                    DecodeHtml({html:data})
                }
            </p>
            {/* <div className="flex flex-col gap-1">
                <span className="text-neutral-500 text-xs 2xl:text-sm font-normal">Range of Monthly Salary (from fresh to senior position):</span>
                <h1 className=" text-black text-2xl font-bold ">RM2,000 – RM25,000</h1>
                <span className="text-neutral-500 text-xs 2xl:text-sm font-normal">Source: Jobstreet Salary Report and Kelly Services (Malaysia) Salary Guide.</span>
            </div>
            <div className="flex flex-col gap-1">
                <span className="text-neutral-500 text-xs 2xl:text-sm font-normal">Employability Rate (within 6 months of Graduation):</span>
                <h1 className=" text-black text-2xl font-bold  ">
                    94.0% Employed | 6.0% Job Creators / Further Study
                </h1>
                <span className="text-neutral-500 text-xs 2xl:text-sm font-normal">Source: Ministry of Education Malaysia’s Graduate Tracer Study.</span>
            </div> */}
        </div>
    )
}
CareerProspect.propTypes = {
    data:PropTypes.string
}
export default CareerProspect